import { formatDate } from "date-fns";
import { downloadCSVfromBase64 } from "../../../../lib/utils";
import { colors } from "../../../../ui/colors";
import { CheckCircleIcon } from "../../../../ui/icons/checkCircle";
import { DownloadIcon } from "../../../../ui/icons/download";
import { XCircleIcon } from "../../../../ui/icons/xCircle";
import Button from "../../../../ui/molecules/button";
import { ImportCSVResponseDTO } from "../../dto";
import { ContactMissed } from "./contactMissed";

interface Props {
  importResponse?: ImportCSVResponseDTO;
  showModal: boolean;
  onClose: () => void;
}

export function ImportModalContacts(props: Props) {
  const notImported = props.importResponse ? (props.importResponse.errors + props.importResponse.duplicates) : 0;
  const isSuccess = props.importResponse !== undefined;

  if (!props.showModal) return null;

  return (
    <div
      onClick={props.onClose}
      className="transition-all fixed bg-opacity-30 bg-neutral-950 backdrop-blur-sm top-0 left-0 h-full w-full flex items-center justify-center z-[100]"
    >
      <div
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        className="transition-all flex flex-col items-center gap-5 px-[40px] py-6 bg-white rounded-[30px] opacity-100 shadow-sm min-w-[400px]"
      >
        {
          isSuccess && notImported > 0 ?
            <ContactMissed importResponse={props.importResponse!} onClose={props.onClose} /> :
            <>
              {isSuccess ? (
                <CheckCircleIcon color={colors.green[500]} size={70} />
              ) : (
                <XCircleIcon color={colors.red[500]} size={70} />
              )}
              <span className="text-text-2xl font-semibold text-neutral-800">
                {isSuccess
                  ? props.importResponse?.successIds.length +
                  " contatti importati con successo"
                  : "Impossibile importare i contatti"}
              </span>
              {props.importResponse !== undefined &&
                notImported > 0 && (
                  <div className="flex flex-col gap-3 bg-neutral-50 p-6 rounded-[16px]">
                    <span className="text-text-md font-medium text-neutral-700 text-start justify-start items-start w-full">
                      Attenzione
                    </span>
                    <span className="text-text-md font-medium text-neutral-700 text-start justify-start items-start w-full">
                      {notImported} contatti{" "}
                      <span className="font-normal">
                        presentano errori o duplicati e non sono stati
                        importati
                      </span>
                    </span>
                  </div>
                )}
              <div className="w-[30%]">
                <Button
                  size={"md"}
                  iconPosition={"off"}
                  variant={"solid"}
                  color={isSuccess ? "green" : "red"}
                  fullWidth
                  label="OK"
                  onClick={props.onClose}
                />
              </div>
              {props.importResponse?.base64CsvMissed && (
                <Button
                  size={"md"}
                  iconPosition={"left"}
                  variant={"link"}
                  color={"blue"}
                  label="Scarica lista contatti non importati"
                  icon={<DownloadIcon color={""} size={0} />}
                  onClick={() => {
                    downloadCSVfromBase64(props.importResponse?.base64CsvMissed!, "cd_missed_people_download_" + formatDate(new Date(), "dd_MM_yyyy"))
                  }}
                />
              )}
            </>
        }
      </div>
    </div>
  );
}
